'use strict';
const _ = require('underscore');
const Message = require('bunsen/models/usercomm/Message');
const Backbone = require('dibs-backbone');
const endpoints = require('dibs-endpoints');
const extendCompose = require('bunsen/libraries/extendCompose');
const Item = require('bunsen/models/inventory/Item');
const MessageRecipient = require('bunsen/models/usercomm/MessageRecipient');
const ConversationMember = require('bunsen/models/usercomm/ConversationMember');
const Party = require('bunsen/models/Party');
const ContactDealerMessage = module.exports = extendCompose.call(Message, {});

ContactDealerMessage.extendSelf({
    url: endpoints.messageNewConversation,

    defaults__: {
        from: {
            displayName: '',
            discloseEmail: 'N'
        }
    },

    relations__(relations) {
        return relations.concat([{
            type: Backbone.One,
            key: 'item',
            relatedModel: Item,
            saveJSONFields : ['id', 'apiType']
        }]);
    },

    initialize(data, options) {
        options = _.extend({
            item: undefined,
            seller: undefined,
            isNetPrice: false
        }, options);
        this._isNetPrice = options.isNetPrice;
        if (options.item) {
            this.setItem(options.item);
        } else if (options.seller) {
            this.setSeller(options.seller);
        }
        if (options.fromUser) {
            this.setFromUser(options.fromUser);
        }
        this.setAction(Message.MC_ACTIONS[this._isNetPrice ? 'netPrice' : 'contactDealer']);
    },

    setItem(item) {
        this.set({
            context: this._isNetPrice ? ContactDealerMessage.context.itemNetPrice : ContactDealerMessage.context.item,
            item
        });
        this.setToSeller(item.get('seller'));
    },

    setSeller(seller) {
        this.set('context', ContactDealerMessage.context.seller);
        this.setToSeller(seller);
    },

    setFromUser(user) {
        this.set('from', new ConversationMember({
            user: user.pick('id'),
            displayName: ([user.get('profile.firstName') || '', user.get('profile.lastName') || ''].join(' ')).trim(),
            userEmail: user.get('profile.email'),
            userType: Party.ROLE_BUYER
        }));
    },

    setToSeller(seller) {
        this.set('recipients', [
            new MessageRecipient({
                recipientDetails: new ConversationMember({
                    user: seller.pick('id'),
                    displayName: seller.get('sellerProfile.company'),
                    userEmail: seller.get('sellerProfile.email'),
                    userType: Party.ROLE_SELLER
                })
            })
        ]);
    },

    getFirstRecipientName() {
        return this.get('recipients[0].recipientDetails.displayName');
    }
});

Object.assign(ContactDealerMessage, {
    context: {
        item: 'CONTACT_SELLER_PDP',
        itemNetPrice: 'CONTACT_SELLER_NET_PRICE',
        seller: 'CONTACT_SELLER_STOREFRONT'
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/models/usercomm/ContactDealerMessage.es.js